<template>
  <div>
    <CAlert color="warning" closeButton :show.sync="alert">
      {{ alertText }}
    </CAlert>
    <CForm class="needs-validation" novalidate>
      <CRow>
        <CCardBody>
          <CRow>
            <date-picker
              placeholder="از تاریخ"
              class="col-sm-12 col-md-6 col-lg-3 mt-1"
              v-model="info.fromDate"
              :value="info.fromDate"
              :autoSubmit="true"
              required
            ></date-picker>

            <date-picker
              placeholder="تا تاریخ"
              class="col-sm-12 col-md-6 col-lg-3 mt-1"
              v-model="info.toDate"
              :value="info.toDate"
              :autoSubmit="true"
              required
            ></date-picker>
          </CRow>

          <CRow class="justify-content-center mt-4">
            <CButton
              @click="recieveAction('DeleteLocationAndSensorValueGetLog')"
              color="info"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-cloud-download" class="mx-1" />دریافت
              (حذف/جایگزینی)</CButton
            >
            <CButton
              @click="recieveAction('GetLog')"
              color="info"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-cloud-download" class="mx-1" />دریافت
              (Overwrite)</CButton
            >
            <CButton
              @click="deleteAction()"
              color="danger"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-trash" class="mx-1" />حذف</CButton
            >
            <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
          </CRow>
        </CCardBody>
      </CRow>
    </CForm>
    <!-- ********************************************************************* alert -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle == 'دریافت لاگ'"
          @click="
            alertModal = false;
            recieveLog();
          "
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف لاگ'"
          @click="
            alertModal = false;
            deleteLog();
          "
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
import $ from "jquery";

export default {
  props: ["deviceId"],
  data() {
    return {
      info: { fromDate: "", toDate: "" },
      alert: false,
      alertText: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",

      whichRecieve:"",
    };
  },

  mounted() {},

  methods: {
    // *****************************************************************restore Default
    recieveLog() {
      console.log(this.deviceId);

      if (this.info.fromDate == "" || this.info.toDate == "") {
        this.alert = true;
        this.alertText = "بازه تاریخ را انتخاب نمایید!!!";
      } else {
        var d1 = new Date(this.info.fromDate);
        var d2 = new Date(this.info.toDate);

        var df = d2 - d1;
        var dfDay = Math.round(df / 24 / 60 / 60 / 1000);
        console.log(dfDay);
        if(dfDay>6)
        {
          this.alert = true;
        this.alertText = "بازه انتخابی نباید بیش از هفت روز باشد!!!";
        }else
        {
          axios
          .post(Values.serverIp + "Device/"+this.whichRecieve , {
             deviceId: this.deviceId,
            fromDate: this.info.fromDate,
            toDate: this.info.toDate,
          })
          .then((response) => {
            if (response.status == 200 ) {
              this.$emit("update", 1);
            }
          })
          .catch((error) => {
            this.$emit("update", 2);
            console.log(error);
          });
        }
      }
    },
    // *****************************************************************restore Default
    deleteLog() {
      if (this.info.fromDate == "" || this.info.toDate == "") {
        this.alert = true;
        this.alertText = "بازه تاریخ را انتخاب نمایید!!!";
      } else {
        var d1 = new Date(this.info.fromDate);
        var d2 = new Date(this.info.toDate);

        var df = d2 - d1;
        var dfDay = Math.round(df / 24 / 60 / 60 / 1000);
        console.log(dfDay);
        if(dfDay>6)
        {
          this.alert = true;
        this.alertText = "بازه انتخابی نباید بیش از هفت روز باشد!!!";
        }else
        {
          axios
          .post(Values.serverIp + "Device/DeleteLocationAndSensorValue" , {
            deviceId: this.deviceId,
            fromDate: this.info.fromDate,
            toDate: this.info.toDate,
          })
          .then((response) => {
            if (response.status == 200 ) {
              this.$emit("update", 1);
            }
          })
          .catch((error) => {
            this.$emit("update", 2);
            console.log(error);
          });
        }
      }
    },

    //****************************************************************** delete action */
     deleteAction() {
      (this.alertModal = true);
        (this.alertModalTitle = "حذف لاگ");
        (this.alertModalText =
          "آیا نسبت به حذف لاگ در بازه موردنظر اطمیان دارید؟");
        (this.alertModalColor = "warning");
        (this.alertModalButtonText = "بله");
        
    },

    //****************************************************************** recieve action */

     recieveAction(data) {
      this.whichRecieve=data;
      (this.alertModal = true);
        (this.alertModalTitle = "دریافت لاگ");
        (this.alertModalText =
          "آیا نسبت به دریافت لاگ در بازه موردنظر اطمیان دارید؟");
        (this.alertModalColor = "warning");
        (this.alertModalButtonText = "بله");
        
    },


    // *****************************************************************restore Default
    restoreDefault() {
      console.log(this.deviceId);

      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      this.info.fromDate = "";
      this.info.toDate = "";
    },
  },
};
</script>

<style>
</style>